@if (type === feedbackVariants.MOOD_FULL) {
    <div class="feedback__buttonGroup">
        @for (mood of moodOptions; track mood) {
            <button
                type="button"
                (click)="openFeedback(mood.value)"
                (keydown.enter)="openFeedback(mood.value)"
                (keydown.space)="openFeedback(mood.value)"
                [attr.aria-label]="'mijn-feedback.label.' + mood.id | apContent"
            >
                <span [apInlineSVG]="getSvgSource(mood.id)" [setSVGAttributes]="{ width: '24px', height: '24px' }"> </span>
                <span class="feedback__buttonGroup__label">{{ 'mijn-feedback.label.' + mood.id | apContent }}</span>
            </button>
        }
    </div>
}

@if (type === feedbackVariants.MOOD_SIDEBAR) {
    <ap-button
        variant="aside"
        (onClick)="openFeedback(null)"
        (keydown.enter)="openFeedback(null)"
        (keydown.space)="openFeedback(null)"
        id="sidebarButton"
        [compact]="true"
    >
        {{ this.sidebarLabel }}
    </ap-button>
}
